var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"300"}},[_c('v-expansion-panels',_vm._l((_vm.renderStates),function(item,i){return _c('v-expansion-panel',{key:i + _vm.reference},[_c('v-expansion-panel-header'),_c('v-expansion-panel-content')],1)}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }